const NewsService = (function () {
    'use strict';

    const LG_MIN_WIDTH = 1200;
    const NEWS_ROOT_ROUTE = "/news";
    let isNeedReset = false;
    let isNeedResetWidth = false;

    function setHeight() {
        const news = document.getElementById('news');
        const fixedNews = document.getElementById('fixedNews');
        const containerNews = document.getElementById('js-container-news');
        const newsElems = Array.from(document.getElementsByClassName('news-elem'));

        if (news != null && $(window).width() >= LG_MIN_WIDTH) {
            const topHeight = document.getElementById('navbarFixedTop').offsetHeight;
            const bottomHeight = document.getElementById('navbarFixedBottom').offsetHeight;
            const newHeight = $(window).height() - topHeight - bottomHeight;

            news.style.height = `${newHeight}px`;
            fixedNews.style.height = `100%`;
            containerNews.style.height = `${newHeight}px`;

            newsElems.forEach(elem => {
                elem.style.height = `${newHeight / 2}px`;
                if (elem.classList.contains('news-last-elem')) {
                    elem.style.marginBottom = `${bottomHeight}px`;
                }
            });
            isNeedReset = true;
        } else {
            if (isNeedReset) {
                news.style.height = '';
                fixedNews.style.height = '';
                containerNews.style.height = '';

                newsElems.forEach(elem => {
                    elem.style.height = '';
                    if (elem.classList.contains('news-last-elem')) {
                        elem.style.marginBottom = '';
                    }
                });
                isNeedReset = false;
            }
        }
    }

    function setWidth() {
        const row = document.getElementById('js-row-news');
        const containerNews = document.getElementById('js-container-news');
        if (row != null && $(window).width() >= LG_MIN_WIDTH) {
            const newWidth = row.offsetWidth;
            containerNews.style.width = `${newWidth + 1}px`;
            isNeedResetWidth = true;
        } else {
            if (isNeedResetWidth) {
                containerNews.style.width = '';
                isNeedResetWidth = false;
            }
        }    
    }

    function makeRedirect() {
        $('.js-fixed-news, .js-news-elem').click(event => {
            AppService.redirectTo(`${NEWS_ROOT_ROUTE}/${$(event.currentTarget).data('news-id')}`);
        });
    }

    function init() {
        makeRedirect();
        setHeight();
        setWidth();
        $(window).resize(setHeight);
        $(window).resize(setWidth);
    }

    return {
        init: init
    };
})();

$(NewsService.init);
